var _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIptvisionsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 420 96",
    role: "img",
    "aria-label": "IPTVISIONS",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IPTVISIONS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57 18 C31 18 23 34 39 45 C52 54 74 52 78 67 C81 80 67 86 47 86 C35 86 25 82 18 76",
    stroke: "#E6B93D",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 78 C68 78 76 62 60 51 C47 42 25 44 21 29 C18 16 32 10 52 10 C64 10 74 14 81 20",
    stroke: "#F5F6F8",
    strokeWidth: 15
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 112,
    y: 61,
    fill: "#F5F6F8",
    fontFamily: "Manrope, Inter, Montserrat, Arial, sans-serif",
    fontSize: 38,
    fontWeight: 800,
    letterSpacing: 2.6
  }, "IPTVISIONS")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIptvisionsLogo);
export default __webpack_public_path__ + "static/media/iptvisions-logo.bd60da0be85e77fea16584b18910a8e1.svg";
export { ForwardRef as ReactComponent };